module.exports = {"top3":["Alcohol deaths","Adults without all recommended vaccines","Employer-sponsored insurance spending per enrollee"],"bottom3":["Drug poisoning deaths","Children who are overweight or obese","Central line-associated blood stream infection (CLABSI)"],"most_improved":["Home health patients with a hospital admission","Home health patients without improved mobility","Diabetic adults without an annual hemoglobin A1c test"],"most_declined":["Hospital 30-day mortality","Preventable hospitalizations ages 18-64","Drug poisoning deaths"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/MD.json
// module id = 260
// module chunks = 143196823979170 184088790168614